import React, { useRef, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import contriesList from "iso-3166-1-alpha-2";
import { RegexFields } from "../../../../../../../../constants/utils/regexFields";
import * as R from "ramda";
import $ from "jquery";
import * as loadings from "../../../../../../../../constants/loadings/relocationDeclaration";
import { createServiceData, updateServiceData, deleteServiceData } from "../../../../../../../../actions/facilita-api";
import { ConnectionTypes } from "../../../../../../../../constants/utils/connectionTypes";

import { PostalCityInput } from "../../../../../../../../_common/postalCityInput";

export const ModalEducationInstitutionSection = ({ educationInstitution, initCollapsedState, index, isLoading, removeFromList, relocationDeclaration }) => {
	const dispatch = useDispatch();
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	let initState = {
		...educationInstitution.payload,
		address: {
			streetAddress: educationInstitution.payload?.address?.streetAddress || "",
			streetAddress2: educationInstitution.payload?.address?.streetAddress2 || "",
			postalCode: educationInstitution.payload?.address?.postalCode || "",
			addressLocality: educationInstitution.payload?.address?.addressLocality || "",
			addressCountry: educationInstitution.payload?.address?.addressCountry || "FR",
		},
	};
	initCollapsedState = R.isNil(educationInstitution.collapsed) ? initCollapsedState : educationInstitution.collapsed;

	const educationInstitutionForm = useRef(null);
	const [wasValidated, setWasValidated] = useState(false);
	const [payload, setPayload] = useState(initState);
	const [collapsed, setCollapsed] = useState(initCollapsedState);

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	return (
		<section className={"block mb-3"} id={"educationInstitution_" + index}>
			<div className="card-header p-0 mb-3" id={"educationInstitution_" + index + "_heading"} role="button" onClick={() => setTimeout(() => setCollapsed(!collapsed), 200)}>
				<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target={"#ModalEducationInstitutionSection_" + index} aria-expanded={!collapsed} aria-controls={"#ModalEducationInstitutionSection_" + index}>
					<h4 className="h3 font-weight-black container-tight my-auto">{index === 0 ? "Établissement principal" : "Autre établissement"}</h4>
					{!R.isNil(payload.name) ? (
						<span className="mr-auto align-middle">
							<i className="eva eva-arrow-right mx-2 align-middle o-30"></i>
							<span className="o-60 align-middle">{payload.name}</span>
						</span>
					) : (
						""
					)}
					<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-40" name="refPrincipal">
						<i className={"eva " + (!collapsed ? "eva-arrow-ios-upward-outline" : "eva-arrow-ios-downward-outline")}></i>
					</button>
				</div>
			</div>
			<div className={"collapse" + (collapsed ? " show" : "")} id={"ModalEducationInstitutionSection_" + index} aria-labelledby={"educationInstitution_" + index + "_heading"} data-parent={"#educationInstitution_" + index}>
				<form className="block" noValidate ref={educationInstitutionForm}>
					<h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm">nom de l’entreprise</h5>
					<div className="row gx-2 mt-n2">
						<div className="col-12 col-md-5">
							<div className="form-group">
								<label className="h6 font-weight-bolder my-auto" htmlFor={"name"}>
									Nom de l'établissement
								</label>
								<input
									required
									type="text"
									className="form-control"
									id={"name"}
									placeholder="Nom de l'établissement"
									defaultValue={payload.name}
									onChange={(event) => {
										setPayload({ ...payload, name: event.target.value });
									}}
								/>
								<div className={"invalid-feedback" + (payload.name === undefined && wasValidated === true ? " show" : "")}>
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
						</div>
						<div className="col-12 col-md-7">
							<div className="form-group">
								<div className="flex-row gx-2 align-items-center mb-1">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Adresseentreprise"}>
										Adresse ligne 1
									</label>
									<p
										className="form-text small text-gray my-auto ml-auto"
										data-toggle="tooltip"
										data-placement="top"
										data-html="true"
										data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
										title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
										<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
									</p>
								</div>
								<input required type="text" className="form-control" id={"Adresseentreprise" + index} placeholder="Adresse de l'établissement" value={payload.address.streetAddress} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress: e.target.value } })} />
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
							<div className="form-group">
								<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2"}>
									Adresse ligne 2
								</label>
								<input type="text" className="form-control rounded" id={"Adresseligne2" + index} placeholder="(optionnel)" value={payload.address.streetAddress2} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress2: e.target.value } })} />
							</div>
							<div className="form-row">
								<PostalCityInput
									postalCode={payload.address.postalCode}
									city={payload.address.addressLocality}
									onChange={(updatedAddress) => setPayload({ ...payload, address: { ...payload.address, postalCode: updatedAddress.postalCode, addressLocality: updatedAddress.city } })}
									hasWrapper={false}
									country={payload.address.addressCountry}
									customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
								/>
								{/* <div className="form-group col-12 col-sm-6 col-lg">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Postalentreprise"} required>
										Code Postal
									</label>
									{payload.companyAddressCountry === null || payload.companyAddressCountry === "FR" || payload.companyAddressCountry === "GF" || payload.companyAddressCountry === "PF" || payload.companyAddressCountry === "TF" ? (
										<input required type="text" className="form-control" id={"Postalentreprise" + index} placeholder="ex: 75001" value={payload.address.postalCode} pattern={RegexFields.frenchZipCode} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, postalCode: e.target.value } })} />
									) : (
										<input required type="text" className="form-control" id={"Postalentreprise" + index} placeholder="ex: 75001" value={payload.address.postalCode} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, postalCode: e.target.value } })} />
									)}
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
								<div className="form-group col-12 col-sm-6 col-lg">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Villeentreprise"} required>
										Ville
									</label>
									<input required type="text" className="form-control" id={"Villeentreprise" + index} placeholder="ex: Paris" pattern={RegexFields.nameWithoutNumbers} value={payload.address.addressLocality} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressLocality: e.target.value } })} />

									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div> */}
								<div className="form-group col-12 col-sm-6 col-lg">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise"}>
										Pays
									</label>
									<select className="custom-select" id={"Paysentreprise" + index} value={payload.address.addressCountry} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressCountry: e.target.value } })}>
										{Object.keys(contriesList.getData()).map((addressCountry, idx) => (
											<option key={idx} value={addressCountry}>
												{countries.getName(addressCountry, "fr", { select: "official" })}
											</option>
										))}
									</select>
								</div>
							</div>
						</div>
					</div>
					<hr className="mb-4" />
					<h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm">Cursus</h5>
					<div className="row gx-2 mt-n2">
						<div className="col-12 col-md">
							<div className="form-group">
								<label className="h6 font-weight-bolder my-auto" htmlFor={"niveau"}>
									Niveau d'étude
								</label>
								<input required type="text" className="form-control" id={"niveau"} placeholder="ex: BTS, Licence, Master, ..." value={payload.level} onChange={(e) => setPayload({ ...payload, level: e.target.value })} />
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
						</div>
						<div className="col-12 col-md">
							<div className="form-group">
								<label className="h6 font-weight-bolder my-auto" htmlFor={"intitule"}>
									Intitulé de la formation
								</label>
								<input required type="text" className="form-control" id={"intitule"} placeholder="Intitulé" value={payload.label} onChange={(e) => setPayload({ ...payload, label: e.target.value })} />
							</div>
						</div>
					</div>
					<hr className="mb-4" />
					<hr className="my-0" />
					<div className="card-footer text-right px-0">
						{isLoading.includes(loadings.UPDATING_USER_SERVICES_DATA + "_" + educationInstitution.id) || isLoading.includes(loadings.CREATING_USER_SERVICES_DATA + "_" + educationInstitution.serviceId) || isLoading.includes(loadings.UPDATING_RELOCATION_DECLARATION) ? (
							<button type="button" className="btn btn-info loading-btn show">
								<div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder
							</button>
						) : (
							<button
								type="button"
								className="btn btn-info"
								onClick={(e) => {
									e.preventDefault();
									educationInstitutionForm.current.classList.add("was-validated");
									if (educationInstitutionForm.current.checkValidity()) {
										if (R.isNil(educationInstitution.id) || educationInstitution.id === "") {
											dispatch(
												createServiceData({
													...educationInstitution,
													payload: payload,
												})
											).then(() => setCollapsed(!collapsed));
										} else {
											dispatch(
												updateServiceData({
													...educationInstitution,
													payload: payload,
												})
											).then(() => setCollapsed(!collapsed));
										}
										setCollapsed(!collapsed);
									}
								}}>
								Enregistrer
							</button>
						)}
						<button
							className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none"
							id="basic-addon2"
							onClick={(e) => {
								e.preventDefault();
								if (R.isNil(educationInstitution.id)) {
									removeFromList(index);
								} else {
									dispatch(deleteServiceData(educationInstitution.id, ConnectionTypes.etudiant));
								}
							}}>
							<i className="eva eva-trash-outline"></i>
						</button>
					</div>
				</form>
			</div>
		</section>
	);
};
